/**
 * Use this to trigger custom events in our client side app.
 * We use it to refresh the ad after a few clicks.
 *
 * @param {string} eventName - name for custom event
 * @param {object} [data={}}] data - custom data for the event
 * @param {node} [dispatcher=window] dispatcher - what dispatches the event
 * @return {boolean} returns true if triggered
 *
 * @example
 * trigger('FC_AD_REFRESH')
 * // true
 *
 * @external {Events} https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 */
export default function trigger(eventName, data = {}, dispatcher = window) {
  if (typeof eventName !== 'string') {
    return false;
  }

  const event = new CustomEvent(eventName, data);

  dispatcher.dispatchEvent(event);

  return true;
}
